"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.questionTypes = exports.QuestionType = exports.questionCategories = exports.QuestionCategories = void 0;
var QuestionCategories;
(function (QuestionCategories) {
    QuestionCategories["account"] = "Account";
    QuestionCategories["locations"] = "Locations";
    QuestionCategories["days"] = "Days";
    QuestionCategories["routes"] = "Routes";
    QuestionCategories["passes"] = "Passes";
    QuestionCategories["vehicles"] = "Vehicles";
    QuestionCategories["habits"] = "Habits";
    QuestionCategories["demographics"] = "Demographics";
})(QuestionCategories || (exports.QuestionCategories = QuestionCategories = {}));
exports.questionCategories = Object.values(QuestionCategories);
var QuestionType;
(function (QuestionType) {
    QuestionType["textInput"] = "Text Input";
    QuestionType["radioButton"] = "Radio Buttons";
    QuestionType["numberInput"] = "Number Input";
    QuestionType["checkboxes"] = "Checkboxes";
    QuestionType["dropdown"] = "Dropdown";
    QuestionType["gridQuestions"] = "Grid Question";
    QuestionType["addressAutocomplete"] = "Address Autocomplete";
    QuestionType["timeSelector"] = "Time Selector";
    QuestionType["daySelector"] = "Day Selector";
    QuestionType["enterpriseSelector"] = "Enterprise Selector";
    QuestionType["officeSelector"] = "Office Selector";
    QuestionType["vehicleSelector"] = "Vehicle Selector";
    QuestionType["activitySelector"] = "Activity Selector";
    QuestionType["commuteRouter"] = "Commute Router";
    QuestionType["costSelector"] = "Cost Selector";
    QuestionType["homeAddressAutocomplete"] = "Home Address Autocomplete";
    QuestionType["statement"] = "Statement";
})(QuestionType || (exports.QuestionType = QuestionType = {}));
exports.questionTypes = Object.values(QuestionType);
//# sourceMappingURL=Question.js.map